import { useEffect } from 'react';
import Grid from '@mui/material/Grid';
import { useDispatch, useSelector } from 'react-redux';

import { fetchInfoGraphicsData } from 'features/views/dashboard/statistics/actions';
import { getSellectedSeller } from 'features/views/dashboard/statistics/selectors';

import ContactsGraph from './ContactsGraph';
import ProductionsInfo from './ProductionsInfo';
import TasksGraph from './TasksGraph';

export const Infographics = () => {
	const dispatch = useDispatch();
	const selectedSeller = useSelector(getSellectedSeller);

	useEffect(() => {
		dispatch(fetchInfoGraphicsData(selectedSeller));
	}, [dispatch, selectedSeller]);

	return (
		<Grid container>
			<Grid size={12}>
				<Grid container spacing={2}>
					<Grid
						size={{
							xs: 6,
							xl: 4.5,
						}}
					>
						<TasksGraph />
					</Grid>
					<Grid
						size={{
							xs: 6,
							xl: 4.5,
						}}
					>
						<ContactsGraph />
					</Grid>
					<Grid
						size={{
							xs: 12,
							xl: 3,
						}}
					>
						<ProductionsInfo />
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default Infographics;
